import { useEffect, useState } from "react";
import { fetchPromotions } from "../api/promotions";

const parseDate = (date) => {
  if (!date) return null;

  // Cas d'une date provenant d'un input type="date"
  if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return new Date(`${date}T00:00:00`);
  }

  return new Date(date);
};

export function useActivePromotions() {
  const [promotions, setPromotions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const loadPromotions = async () => {
      try {
        setLoading(true);

        const response = await fetchPromotions();

        console.log("Réponse API promotions :", response.data);

        const currentDate = new Date();

        console.log("Date actuelle :", currentDate);

        const activePromotions = response.data.filter((promotion) => {
          const startDate = parseDate(promotion.start);
          const endDate = parseDate(promotion.end);

          console.log("Promotion :", promotion);
          console.log("Date début :", startDate);
          console.log("Date fin avant modification :", endDate);

          if (!startDate || !endDate) {
            return false;
          }

          // La date de fin est incluse jusqu'à 23:59:59
          endDate.setHours(23, 59, 59, 999);

          return currentDate >= startDate && currentDate <= endDate;
        });

        if (!cancelled) {
          setPromotions(activePromotions);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    loadPromotions();

    return () => {
      cancelled = true;
    };
  }, []);

  return {
    promotions,
    loading,
    error,
    hasActivePromotions: promotions.length > 0,
  };
}
